import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { translate } from "react-translate";

import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Form,
    Message,
    Divider,
    Icon,
    Item,
    Select,
    Label,
    Modal,
} from 'semantic-ui-react';

//IMPORT IMAGES
import hommeShapeWhite from '../../assets/icons/homme-shape-white.png'
import hommeShapeGrey from '../../assets/icons/homme-shape-grey.png'
import femmeShapeGrey from '../../assets/icons/femme-shape-grey.png';
import femmeShapeWhite from '../../assets/icons/femme-shape-white.png';
import particulierWhite from '../../assets/icons/particulier-white.png';
import particulierGrey from '../../assets/icons/particulier-grey.png';
import professionelGrey from '../../assets/icons/professionel-grey.png';
import professionelWhite from '../../assets/icons/professionel-white.png';

import SociolComponent from './SociolComponent';


// import GoogleConnexion from './icons/GoogleConnexion.png';
// import FacebookConnexion from './icons/FacebookConnexion.png';
// import WhiteLine from './icons/WhiteLine.png';
// import Homme from './icons/Homme.png';
// import Femme from './icons/Femme.png';
import Exit from '../../assets/svg/Exit.svg';
import EmailSend from '../../assets/icons/EmailSend.png';


import { connect } from 'react-redux';
import './RegisterComponent.css'
import './socialComponent.css'

import { addLanguage, addRegister, addLogin } from '../../redux/actions/AppAction'

import API from '../../services/api';


const mapStateToProps = state => ({
    app: state.app
})

const mapActionToProps = {
    addLanguage: addLanguage,
    addRegister: addRegister,
    addLogin: addLogin,
}

const countryOptions = [
    { key: 'en_GB', flag: 'eng', text: 'England', value: 'en_GB' },
    { key: 'fr_FR', flag: 'fr', text: 'France', value: 'fr_FR' },
    { key: 'es_ES', flag: 'es', text: 'Spain', value: 'es_ES' },
    { key: 'pt_PT', flag: 'pt', text: 'Portugal', value: 'pt_PT' },
    { key: 'ru_RU', flag: 'ru', text: 'Russia', value: 'ru_RU' },
    { key: 'zh_CN', flag: 'nz', text: 'New-Zealand', value: 'zh_CN' },
    { key: 'de_DE', flag: 'de', text: 'Germany', value: 'de_DE' },
    { key: 'it_IT', flag: 'it', text: 'Italy', value: 'it_IT' },
    { key: 'ja_JP', flag: 'jp', text: 'Japan', value: 'ja_JP' },
]

class ConnectedRegisterComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: null,
            password: null,
            password_confirm: null,
            name: null,
            countryId: 250,
            gender: 1,
            country: null,
            postalcode: null,
            type: null,
            oldpass: null,
            newpass: null,
            response: null,
            value: null,
            responseCountry: null,
            user_type: 0,
            error_input_email: true,
            error_input_password: true,
            error_input_passwordconfirm: true,
            error_input_name: true,
            error_input_postal: true,
            warningError: null,
            warningErrorMdp: false,
            warningErrorPostal: false,
            modalOpen: false,
        }

        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeGender = this.handleChangeGender.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
        this.handleChangePostalcode = this.handleChangePostalcode.bind(this);
        this.handleChangeLang = this.handleChangeLang.bind(this);
        this.handleChangeNewpass = this.handleChangeNewpass.bind(this);
        this.handleChangeOldpass = this.handleChangeOldpass.bind(this);

        this.setLang = this.setLang.bind(this);

        this.handleSubmitRegister = this.handleSubmitRegister.bind(this);

        this.handleSubmitCountry = this.handleSubmitCountry.bind(this);

        this.handleClickGender = this.handleClickGender.bind(this);
        this.handleClickPro = this.handleClickPro.bind(this)

        this.handleChange = this.handleChange.bind(this);
        this.addRegister = this.addRegister.bind(this);
        this.handleCloseRenameSecond = this.handleCloseRenameSecond.bind(this)

        this.handleChangePasswordConfirm = this.handleChangePasswordConfirm.bind(this)
        this.openLogin = this.openLogin.bind(this)
    }

    componentDidMount() {
        var pwd = this
        API.getCountries(this.props.app.token, {lang: this.props.app.lang}).then((res) => {
            var response = res.data;
            let tmp = []
            Object.entries(response).map((key, mainindex) => {
                if (key[0] === 'countries') {
                    Object.entries(key[1]).map((key, mainindex) => {
                        var countries = {}
                        countries.key = key[1].pkuid
                        countries.text = key[1].name
                        countries.value = key[1].name
                        tmp.push(countries)
                    })
                }
            })
            pwd.setState({
                responseCountry: tmp
            })
        }, (err) => {
            pwd.setState({
                error: err.error
            })
        });
    }

    handleChange(e, data) {
        let countryId
        Object.entries(this.state.responseCountry).map((key, mainindex) => {
            if (key[1].text === data.value) {
                countryId = key[1].key
            }
        })
        this.setState({
            countryId: countryId,
        })
    }

    reset() {
        this.setState({
            value: null,
        })
    }

    setValue(e, data) {
        this.setState({
            value: data.value
        })
        this.setLang(this.state.value)
    }

    setLang(value) {
        this.props.addLanguage(value)
    }

    addRegister() {
        this.setState({
            warningError: null,
            response: null
        })
        this.props.addRegister(false);
    }

    handleSubmitRegister(event) {
        event.preventDefault();

        let check = false;

        const { t } = this.props;

        if (!this.state.error_input_email && !this.state.error_input_postal && !this.state.error_input_name) {

            if (!this.state.error_input_password && !this.state.error_input_passwordconfirm && this.state.password === this.state.password_confirm) {
                var registerData = {
                    email : this.state.email,
                    password: this.state.password,
                    name: this.state.name,
                    gender: this.state.gender,
                    country: this.state.countryId,
                    postalcode: this.state.postalcode,
                    lang : this.props.app.lang,
                    type: "INT",
                    user_type: this.state.user_type
                }
                API.register(this.props.token, registerData).then((res) => {
                    let modal = false
                    let response = res.data;
                    if (response.code === 200) {
                        modal = true
                    }
                    this.setState({
                        warningErrorMdp: false,
                        warningErrorPostal: false,
                        warningError: null,
                        modalOpen: modal,
                        response: response
                    })
                });
            } else {
                this.setState({
                    warningErrorMdp: true,
                    response: null,
                    warningError: t("error_same_password")
                })
            }

        } else {
            this.setState({
                response: null,
                warningError: t("error_multiple")
            })
        }


    }


    handleSubmitCountry() {
        var pwd = this

        API.getCountries(this.props.app.token, {lang: this.props.app.lang}).then((res) => {
            var response = res.data;
            let tmp = []
            Object.entries(response).map((key, mainindex) => {
                if (key[0] === 'countries') {
                    Object.entries(key[1]).map((key, mainindex) => {
                        var countries = {}
                        countries.key = key[1].pkuid
                        countries.text = key[1].name
                        countries.value = key[1].name
                        tmp.push(countries)
                    })
                }
            })
            pwd.setState({
                responseCountry: tmp
            })
        }, (err) => {
            pwd.setState({
                error: err.error
            })
        });
        
    }

    handleClickGender(e) {
        e.preventDefault();

        let value = e.target.value != undefined ? e.target.value : e.target.getAttribute('value');

        this.setState({
            gender: value,
        })
    }

    handleClickPro(e) {
        e.preventDefault();

        let value = e.target.value != undefined ? e.target.value : e.target.getAttribute('value');

        this.setState({
            user_type: value
        })
    }


    handleChangeEmail(event) {

        if (event.target.value === "" || event.target.value === null || event.target.value === undefined) {
            this.setState({
                email: event.target.value,
                error_input_email: true
            });
        } else {

            this.setState({
                email: event.target.value,
                error_input_email: false
            });
        }
    }

    handleChangeName(event) {

        if (event.target.value === "" || event.target.value === null || event.target.value === undefined) {
            this.setState({
                name: event.target.value,
                error_input_name: true
            });
        } else {

            this.setState({
                name: event.target.value,
                error_input_name: false
            });
        }
    }

    handleChangeGender(event) {
        this.setState({ gender: event.target.value });
    }

    handleChangeCountry(event) {
        this.setState({
            lang: event.target.value
        });
    }

    handleChangeLang(event) {
        this.setState({ lang: event.target.value });
    }

    handleChangePassword(event) {

        if (event.target.value === "" || event.target.value === null || event.target.value === undefined) {
            this.setState({
                password: event.target.value,
                error_input_password: true
            });
        } else {

            this.setState({
                password: event.target.value,
                error_input_password: false
            });
        }
    }

    handleChangePostalcode(event) {

        if (event.target.value === "" || event.target.value === null || event.target.value === undefined) {
            this.setState({
                postalcode: event.target.value,
                error_input_postal: true
            });
        } else {

            this.setState({
                postalcode: event.target.value,
                error_input_postal: false
            });
        }

    }

    handleChangeNewpass(event) {
        this.setState({ newpass: event.target.value });
    }

    handleChangeOldpass(event) {
        this.setState({ oldpass: event.target.value });
    }

    handleChangePasswordConfirm(e) {
        this.setState({
            password_confirm: e.target.value,
            error_input_passwordconfirm: false
        });
    }

    handleCloseRenameSecond() {
        this.setState({
            modalOpen: false
        })
        this.addRegister()
    }

    openLogin() {
        this.props.addRegister(false);
        this.props.addLogin(true);
    }

    render() {

        var errorMessageRegister = {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }

        const { t } = this.props;
        const { value } = this.state


        return (
            <Modal id="modalRegister" size='mini' open={this.props.app.register} style={{ width: '390px' }} observeChanges='true' onClose={this.addRegister}>
                <div ref={node => { this.node = node; }}>
                    <Modal.Content >
                        <Grid
                            textAlign='center'
                            verticalAlign='middle'
                            padded>
                            <Grid.Column textAlign='center' id="modalRegisterContent">
                                <Image onClick={this.addRegister} src={Exit} verticalAlign='middle' floated='right' id="exit"/>

                                <Header as='h2' id="modalRegisterHeader">
                                    {t('modal_titre')}
                                </Header>
                                <br />
                                <SociolComponent />
                                <Divider id="divider" horizontal>{t("Divider1_title")}</Divider>
                                <Form onSubmit={this.handleSubmitRegister} id="formRegister">
                                    {
                                        this.state.error_input_name && this.state.warningError ? (

                                            <input
                                                type='text'
                                                onChange={this.handleChangeName}
                                                placeholder={t('placeholder_name')}
                                                style={{ borderColor: '#db2828' }} />
                                        ) : (
                                                <input
                                                    type='text'
                                                    onChange={this.handleChangeName}
                                                    placeholder={t('placeholder_name')} />
                                            )
                                    }
                                    {
                                        this.state.error_input_email && this.state.warningError ? (
                                            <input
                                                type="email"
                                                onChange={this.handleChangeEmail}
                                                fluid
                                                placeholder={t('placeholder_email')}
                                                style={{ borderColor: '#db2828' }} />
                                        ) : (
                                                <input
                                                    type="email"
                                                    onChange={this.handleChangeEmail}
                                                    fluid
                                                    placeholder={t('placeholder_email')} />
                                            )
                                    }
                                    {
                                        this.state.error_input_password && this.state.warningError || this.state.warningError && this.state.warningErrorMdp ? (
                                            <input
                                                type="password"
                                                onChange={this.handleChangePassword}
                                                fluid
                                                placeholder={t('placeholder_mdp')}
                                                style={{ borderColor: '#db2828' }} />
                                        ) : (
                                                <input

                                                    type="password"
                                                    onChange={this.handleChangePassword}
                                                    fluid
                                                    placeholder={t('placeholder_mdp')} />
                                            )
                                    }
                                    {
                                        this.state.error_input_password && this.state.warningError || this.state.warningError && this.state.warningErrorMdp ? (
                                            <input

                                                type="password"
                                                onChange={this.handleChangePasswordConfirm}
                                                fluid
                                                placeholder={t('placeholder_confirm')}
                                                style={{ borderColor: '#db2828' }} />
                                        ) : (
                                                <input

                                                    type="password"
                                                    onChange={this.handleChangePasswordConfirm}
                                                    fluid
                                                    placeholder={t('placeholder_confirm')} />
                                            )
                                    }

                                    <Grid>
                                        <Grid.Row columns={3} style={{paddingBottom:'0'}}>
                                            <Grid.Column verticalAlign='middle' textAlign='left' width={4}  style={{ flexGrow: '1' }}>
                                                <Item.Header as='h5' className="label">{t('gender')}</Item.Header>
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.gender == 1 ? (
                                                        <Button onClick={this.handleClickGender} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff', marginLeft: '20px' }}>
                                                            <Image value={1} src={hommeShapeWhite} /> {t('male')}
                                                        </Button>

                                                    ) : (

                                                            <Button onClick={this.handleClickGender} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)', marginLeft: '20px' }} >
                                                                <Image value={1} src={hommeShapeGrey} /> {t('male')}
                                                            </Button>

                                                        )
                                                }
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.gender == 0 ? (
                                                        <Button onClick={this.handleClickGender} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff' }}>
                                                            <Image value={0} src={femmeShapeWhite} /> {t('female')}
                                                        </Button>

                                                    ) : (

                                                            <Button onClick={this.handleClickGender} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)' }}>
                                                                <Image value={0} src={femmeShapeGrey} />{t('female')}
                                                            </Button>
                                                        )
                                                }
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={3} style={{paddingBottom:'0'}}>
                                            <Grid.Column verticalAlign='middle' textAlign='left' width={4}  style={{ flexGrow: '1' }}>
                                                <Item.Header as='h5' className="label">{t("pro")}</Item.Header>
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.user_type == 0 ? (

                                                        <Button onClick={this.handleClickPro} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff', marginLeft: '20px' }}>
                                                            <Image value={0} src={particulierWhite} /> {t('particulier')}
                                                        </Button>
                                                    ) : (
                                                            <Button onClick={this.handleClickPro} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)', marginLeft: '20px' }}>
                                                                <Image value={0} src={particulierGrey} /> {t('particulier')}
                                                            </Button>

                                                        )
                                                }
                                            </Grid.Column>
                                            <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                                {
                                                    this.state.user_type == 1 ? (
                                                        <Button onClick={this.handleClickPro} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff' }}>
                                                            <Image value={1} src={professionelWhite} /> {t('professional')}
                                                        </Button>

                                                    ) : (

                                                            <Button onClick={this.handleClickPro} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)' }}>
                                                                <Image value={1} src={professionelGrey} /> {t('professional')}
                                                            </Button>
                                                        )
                                                }
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={2}>
                                            <Grid.Column verticalAlign='top' textAlign='left' width={5}>
                                                <Item.Header as='h5' className="label" style={{ paddingTop: '10px' }}>{t("country")}</Item.Header>
                                            </Grid.Column>
                                            <Grid.Column width={11}>
                                                {
                                                    !this.state.responseCountry && this.state.warningError ? (
                                                        <Dropdown
                                                            selection
                                                            search
                                                            defaultValue='France'
                                                            onChange={this.handleChange}
                                                            options={this.state.responseCountry}
                                                            style={{ borderColor: '#db2828' }}
                                                        />
                                                    ) : (
                                                            <Dropdown
                                                                selection
                                                                search
                                                                defaultValue='France'
                                                                onChange={this.handleChange}
                                                                options={this.state.responseCountry}
                                                                style={{ borderColor: 'rgb(160, 160, 160)' }}
                                                            />
                                                        )
                                                }

                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                    {
                                        this.state.error_input_postal && this.state.warningError || this.state.warningError && this.state.warningErrorPostal ? (
                                            <input
                                                selection
                                                onChange={this.handleChangePostalcode}
                                                fluid
                                                placeholder={t("placeholder_postal")} style={{ borderColor: '#db2828' }} />
                                        ) : (
                                                <input
                                                    selection
                                                    onChange={this.handleChangePostalcode}
                                                    fluid
                                                    placeholder={t("placeholder_postal")} />
                                            )
                                    }


                                    {
                                        this.state.warningError ? (
                                            <Grid.Column style={{ paddingBottom: '15px' }} >
                                                <Segment inverted color='red' tertiary style={errorMessageRegister}>
                                                    <Icon name={"remove circle"} />{this.state.warningError}
                                                </Segment>
                                            </Grid.Column>
                                        ) : (
                                                <div></div>
                                            )
                                    }
                                    {
                                        this.state.response ? (

                                            this.state.response.code === 200 ? (
                                                <Modal id="modalRegister" style={{ width: '390px' }} observeChanges='true' size='mini' open={this.state.modalOpen} >
                                                    <Modal.Content style={{padding: '0'}}>
                                                        <Grid
                                                            textAlign='center'
                                                            style={{ height: '100%' }}
                                                            verticalAlign='middle'>
                                                            <Grid.Column style={{ maxWidth: '390px' }}>
                                                                <Image onClick={this.handleCloseRenameSecond} src={Exit} centered floated='right' id="exit" />
                                                                <Header as='h2' id="modalRegisterHeader" textAlign='center'>
                                                                    {t('welcome')}
                                                                </Header>

                                                                <Grid
                                                                    textAlign='center'
                                                                    style={{ height: '100%', margin: "0px" }}
                                                                    verticalAlign='middle'
                                                                >
                                                                    <Grid.Column textAlign={"center"} verticalAlign={"middle"} >
                                                                        {/* La source étant un bool, cela faisait crash le site, que devait être la source ?
                                                                    <Image centered src={check} style={{ width: "50px" }} />*/}
                                                                        <Image src={EmailSend} id="emailSendIcon"/>
                                                                        <Header as='h5' id="account">
                                                                            {t('confirm')}
                                                                        </Header>
                                                                    </Grid.Column>
                                                                </Grid>
                                                            </Grid.Column>
                                                        </Grid>
                                                    </Modal.Content>

                                                    <Modal.Actions style={{ textAlign: 'center' }}>
                                                      <Button
                                                        color='red'
                                                        size="medium"
                                                        style={{fontFamily: 'MavenProBold'}}
                                                        onClick={this.openLogin}>
                                                        {t('connect')}
                                                      </Button>
                                                    </Modal.Actions>

                                                </Modal>

                                            ) : (

                                                    this.state.response.code === 302 ? (
                                                        <Grid.Column style={{ paddingBottom: '15px' }} >
                                                            <Segment inverted color='red' tertiary style={errorMessageRegister}>
                                                                <Icon name={"remove circle"} />{t('error_mail')}
                                                            </Segment>
                                                        </Grid.Column>
                                                    ) : (
                                                            <div></div>
                                                        )
                                                )
                                        ) : (
                                                <div></div>
                                            )
                                    }
                                    <Button fluid size='large' color='yellow' id="submitRegisterBtn">{t('sub')}</Button>
                                </Form>

                                <Header as='h5' id="account">{t('al_account')}<a onClick={this.openLogin} id="modalRegisterLink"> <u>{t('connect')}</u></a></Header>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </div>
            </Modal>
        );
    }
}

const RegisterComponent = connect(mapStateToProps, mapActionToProps)(ConnectedRegisterComponent);
export default translate("RegisterComponent")(RegisterComponent);



// WEBPACK FOOTER //
// ./src/components/Login/RegisterComponent.js